<!-- 输入框  文本、数值-->
<template>
  <div class="cashierdiary--inpout-c">
    <el-input
      class="cashierdiary--inpout"
      :placeholder="'请输入' + tdItem.columnName"
      v-model="editInput"
      :disabled="tdItem.valueType===1"
    >
      {{ calculation(tdItem) }}
    </el-input>
    <span v-if="tdItem.unit" class="cashierdiary--inpout-c-unit">
      {{ tdItem.unit }}
    </span>
  </div>
</template>

<script>
  export default {
    props:{
      inputTip:{
        type:String,
        default:"请输入数值内容"
      },
      value:[String,Number],
      tdItem:[Object],
      tableList:[Array],   //源表格数据  用于自动计算

    },
    data() {
      return {
        allData:{  // 用于自动计算用
          debitMoney:0,
          creditorMoney:0
        }
      }
    },
    computed:{
      editInput:{
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods:{
      calculation(data) {
        this.getData();
        if(data.valueType=='1'){
        	 data.value=eval(data.formula)?eval(data.formula):0;
        }
      },
      getData() {
        // 找出所有的可能参与计算的数值项
        let newArr = [];
        this.tableList.forEach(arr=>{
          arr.forEach(i=>{
            newArr.push(i);
          })
        })
        let numList = newArr.filter(i=>{ return i.customType=='3' });
        numList.forEach(item=>{   // 组装数据
          if(item.columnName === "收入") {
            this.allData.debitMoney=Number(item.value)
          }else if(item.columnName === "支出") {
             this.allData.creditorMoney=Number(item.value)
          }else {
            let label = "field_" + item.id;
            this.allData[label]=item.value?Number(item.value):0;
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../../assets/css/cashierdiary/input.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-number.vue